module.exports = __webpack_public_path__ + "static/media/title_panoramic.5549c035.png";